import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { GraphQLAPI, GraphQLResult, queries } from "@examspark/api";
import { delayForIndexing } from "@examspark/common";
import {
  IDSK,
  ParsedExternalLink,
  Resource,
  SerializedExternalLink,
  Workspace,
} from "@examspark/types";

export const useQueryGetExternalLink = (key: Partial<IDSK>) => {
  return useQuery<Resource>({
    queryKey: ["external-link", key.id],
    enabled: !!key.id,
    queryFn: async () => {
      const result = (
        (await GraphQLAPI.query({
          query: queries.resource.getResource({
            fields: `
              id
              sk
              workspaceId
              name
              type
              data 
            `,
          }),
          variables: key,
        })) as any
      ).data.getResource;

      return result;
    },
  });
};

export const useMutationCreateExternalLink = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (input: ParsedExternalLink) => {
      // increment workspace number
      const incrementResult = (await GraphQLAPI.query<{
        incrementWorkspaceCounter: Workspace;
      }>({
        query: queries.workspace.incrementWorkspaceNumber,
        variables: {
          input: {
            id: input.workspaceId,
            sk: "workspace",
          },
        },
      })) as GraphQLResult<{
        incrementWorkspaceCounter: Workspace;
      }>;

      if (!incrementResult.data?.incrementWorkspaceCounter.counter) {
        throw new Error("Unable to genereate new workspace number.");
      }

      const { data, ...rest } = input;
      const serialized: SerializedExternalLink = {
        ...rest,
        data: JSON.stringify(data),
      };
      const idInc =
        incrementResult.data?.incrementWorkspaceCounter.counter.toString();

      // create resource
      const createResult = (await GraphQLAPI.query<{
        createResource: Resource;
      }>({
        query: queries.resource.createResource(),
        variables: {
          input: {
            ...serialized,
            idInc,
          },
        },
      })) as GraphQLResult<{
        createResource: Resource;
      }>;

      await delayForIndexing();

      queryClient.invalidateQueries(["resources"]);

      console.log("result", createResult);
      return serialized;
    },
  });
};
